















import { log } from '@/log'
import {
  AvailableMemberPlanRepository,
  DefaultAvailableMemberPlanRepository
} from '@/models/api/paid-member-price/member-plan/available-member-plan-repository'
import {
  AvailableMembershipPlan,
  SubscribedPaidMembershipPlan,
} from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import CurrentTime from '@/models/current-time/CurrentTime'
import * as CurrentTimeFactory from '@/models/current-time/functions'
import {
  LastActiveDateSpecification,
  onlyWithinTheUnsubscribedMonth,
} from '@/models/paid-membership/last-active-date-specification'
import { ApiClientWithAuth } from '@/services/api/client'
import { AvailablePaidMemberPlanService } from '@/services/api/paid-member-plan'
import AppId from '@/util/appid'
import CompleteUnsubscribe from '@spa/components/pages/paid-membership/unsubscribe/state/CompleteUnsubscribe.vue'
import ErrorRead from '@spa/components/pages/paid-membership/unsubscribe/state/ErrorRead.vue'
import ErrorUnsubscribe from '@spa/components/pages/paid-membership/unsubscribe/state/ErrorUnsubscribe.vue'
import NotSubscribedNow from '@spa/components/pages/paid-membership/unsubscribe/state/NotSubscribedNow.vue'
import Subscribed from '@spa/components/pages/paid-membership/unsubscribe/state/Subscribed.vue'
import LoadingMixin from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import Vue, { VueConstructor } from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

interface State {
  Loading: VueConstructor
  Subscribed: VueConstructor
  NotSubscribedNow: VueConstructor
  ErrorRead: VueConstructor
  ErrorUnsubscribe: VueConstructor
  CompleteUnsubscribe: VueConstructor
}
const stateComponents: State = {
  Loading: Vue.extend({
    name: 'Loading',
    template: '<div class="loading"></div>',
  }),
  Subscribed,
  NotSubscribedNow,
  ErrorRead,
  ErrorUnsubscribe,
  CompleteUnsubscribe,
}
@Component({
  components: { ...stateComponents },
})
export default class UnsubscribePaidMembership
  extends Mixins<LoadingMixin & PluginMixin>(LoadingMixin, PluginMixin) {
  @Prop({ required: true })
  readonly planId: string

  @Prop({ required: true })
  readonly subscriptionId: string

  @Prop({ default: () => new DefaultAvailableMemberPlanRepository(new AvailablePaidMemberPlanService()) })
  readonly paidMembershipPlanRepository: AvailableMemberPlanRepository

  @Prop({ default: () => onlyWithinTheUnsubscribedMonth })
  readonly lastActiveDateSpecification: LastActiveDateSpecification

  plan: AvailableMembershipPlan | null = null
  lastActiveDateAfterUnsubscribe: Date | null = null
  state: keyof State = 'Loading'

  loading: boolean = false

  get current(): CurrentTime {
    return CurrentTimeFactory.create()
  }

  async created() {
    this.loading = true

    try {
      this.plan = await this.paidMembershipPlanRepository
        .findBy(this.planId, this.subscriptionId)

      /**
       * 解約した結果いつが最終日になるかは、実際に解約するかルールに照らして判断しないと分からないため、
       * オブジェクトの取得とは別に、算出を実施.
       */
      this.lastActiveDateAfterUnsubscribe = await this.lastActiveDateSpecification
        .whenUnsubscribedAt(this.plan, this.current.now)

      this.state = this.plan.subscribed() ? 'Subscribed' : 'NotSubscribedNow'
    } catch (error) {
      log.error(error)

      this.state = 'ErrorRead'
    } finally {
      this.loading = false
    }
  }
  get isLoading(): boolean {
    return this.loading
  }

  onUnsubscribe(targetPlan: SubscribedPaidMembershipPlan) {
    this.loading = true

    /**
     * 解約に伴って事前/事後処理が必要になったら、独自API化する.
     * そうした事前/事後処理が無い内は、実装を簡単にするためproxyを利用.
     *
     * @see https://my-color.esa.io/posts/745#%E6%9C%89%E6%96%99%E4%BC%9A%E5%93%A1%E8%A7%A3%E7%B4%84
     */
    ApiClientWithAuth.post(`/api/user-proxy/${AppId.getHostId()}/commerce_unsubscribe`, {
      id: targetPlan.subscribeId,
    }).then(() => {
      this.state = 'CompleteUnsubscribe'

      /**
       * キャッシュ破棄
       * @see https://github.com/my-color/front/issues/6328#issuecomment-1099649686
       */
      this.$store.dispatch('user/unload')
    }).catch((error) => {
      log.error(error)

      this.state = 'ErrorUnsubscribe'
    }).finally(() => {
      this.loading = false
    })
  }
}
